<template>
	<v-dialog max-width="400" :value="true" persistent>
		<v-card>
			<v-card-title class="text-body-1" style="word-break: normal">
				{{ $t('label.confirm-email-for-sign-in') }}
			</v-card-title>
			<v-card-text style="padding: 0 16px">
				<ValidationObserver
					ref="email_link_sign_in_form"
					tag="form"
					@submit="handleSubmit"
					id="email_link_sign_in_form"
				>
					<v-container>
						<v-row>
							<v-col>
								<ValidationProvider rules="required|email" v-slot="{ errors }">
									<v-text-field
										v-model="email"
										:label="`${$t('label.email')}*`"
										flat
										hide-details
										outlined
										:error-messages="errors"
										name="email"
										type="email"
										dense
										@keydown.enter="handleSubmit"
									></v-text-field>
								</ValidationProvider>
							</v-col>
						</v-row>
						<v-row v-if="errorMessage">
							<v-col class="py-0">
								<p class="error--text mb-0" style="font-size: 0.85rem">
									{{ errorMessage }}
								</p>
							</v-col>
						</v-row>
					</v-container>
				</ValidationObserver>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" :loading="loading" @click="handleSubmit">
					{{ $t('button.confirm') }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
	name: 'EmailLinkSignInDialog',
	components: {
		ValidationObserver,
		ValidationProvider,
	},
	props: {
		errorMessage: {
			type: String,
			default: null,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			email: '',
		};
	},
	methods: {
		async handleSubmit(evt) {
			if (evt) {
				evt.preventDefault();
			}

			const isValid = await this.$refs.email_link_sign_in_form.validate();

			if (isValid) {
				this.$emit('submit', this.email.trim().toLowerCase());
			}
		},
	},
};
</script>
